import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import NavigationClose from 'material-ui-legacy/svg-icons/navigation/close'

const defaultStyle = {
  margin: "11px 13px 0 0",
  paddingTop: "9px",
  height: "32px"
}

const LogoutButton = (props) => (
  <RaisedButton
    style={props.style || defaultStyle}
    onTouchTap={props.onTouchTap}
    label={props.label || "Logout"}
    labelPosition="after"
    icon={<NavigationClose/>}
    {...props}
  />
)

export default LogoutButton



// WEBPACK FOOTER //
// ./src/components/UI/LogoutButton.jsx